import { DeleteOutlined } from '@ant-design/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@/components/Box';
import LeaseAgreementSize from '@/components/LeaseAgreementSize';
import Tag from '@/components/Tags/UsageCategoryTags';
import { LeaseAgreementListPreviewValuesFragment } from '@/generated/graphql';

interface Props {
  leaseAgreement: LeaseAgreementListPreviewValuesFragment;
  isMobile?: boolean;
  showSize?: boolean;
}

function LeaseAgreementListPreview({
  leaseAgreement,
  isMobile,
  showSize = false,
}: Props): React.ReactElement {
  const { t } = useTranslation();
  const { address, title, image, usageCategory, disabled } = leaseAgreement;
  return (
    <div className="flex flex-col gap-2">
      {disabled && (
        <div className="px-3 py-2 rounded-md bg-red-50 border border-solid border-red-200 text-red-600 text-sm font-semibold">
          {t('The listing has been removed')}
        </div>
      )}
      <div className="flex items-start gap-2 justify-between">
        <div className="space-y-2 mr-2">
          <div className="font-semibold">
            {address.street} {address.streetNumber}
          </div>
          <div>
            {address.zipCode} {address.city}
          </div>

          <div className="text-zinc-500">{title}</div>
          {showSize && (
            <div>
              <LeaseAgreementSize
                size={leaseAgreement.size}
                sizeSpan={leaseAgreement.sizeSpan}
                showNotSpecified
              />
            </div>
          )}

          <div className="m-mobile:max-w-96 gap-1 flex flex-wrap">
            {usageCategory.map(category => (
              <Tag
                usageCategory={category}
                key={category}
                size={'small'}
                inverted
              />
            ))}
          </div>
        </div>

        <img className="rounded w-48 object-cover" src={image?.url} alt={''} />
      </div>
    </div>
  );
}

export default LeaseAgreementListPreview;
